import type { Event } from '@patsnap/tahiti-core';

/**
 * 报告访问权限状态服务。
 */
export interface ReportAccessStateService {
    /** 当前报告是否处于无权限状态。 */
    readonly denied: boolean;
    /** 当前无权限报告的 Owner 展示信息。 */
    readonly reportOwner: string;
    /** 报告无权限状态变化事件。 */
    readonly onDeniedChange: Event<boolean>;
    /** 报告 Owner 展示信息变化事件。 */
    readonly onReportOwnerChange: Event<string>;
    /**
     * 处理报告请求错误。
     * @param error 请求错误
     * @returns 是否为报告无权限错误
     */
    handleError(error: unknown): boolean;
    /** 恢复报告可访问状态。 */
    restore(): void;
}

export const ReportAccessStateService = Symbol.for('ReportAccessStateService');
